export default "__VITE_ASSET__CkMi74jV__"